// @ts-nocheck
import { FC, useCallback, useState, useEffect } from 'react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { Chip } from '@mui/material'
import { Box } from '@mui/system'
import ChatIcon from '@mui/icons-material/Chat';
import debounce from 'lodash.debounce';
import { useField, useFormikContext } from 'formik'
import { ELEMENT_RADIUS_MID } from 'utils/customizedTheme'

interface IProps {
  fieldProps: {
    name: string
    label: string
    type?: string
    min?: number
    max?: number
    required?: boolean
  }
  onChange?: any
  valueSelector?: string
  disabled?: boolean
  icon?: JSX.Element
  noIcon?: boolean
  label?: string
  hide?: boolean
  width?: string
  height?: string
}

const RichTextField: FC<IProps> = ({ fieldProps, valueSelector, onChange, disabled, icon = <ChatIcon/>, noIcon, label, hide, width, height }) => {
  const [field, meta] = useField(fieldProps.name)
  const { setFieldValue } = useFormikContext()
  const { error } = meta


  const data = valueSelector ? field.value[valueSelector] : field.value

  const onChangeHandler = (event: any, editor: any) => {
    const data = editor.getData()  
    //setFieldValue(fieldProps.name, data)
    setFormValue(data)
    if (onChange) onChange(data)
  }

  
  const debouncedChangeHandler = useCallback(
    debounce(onChangeHandler, 500)
  , []);
  


  const [hideToolbar, setHideToolbar] = useState(true);

  useEffect(() => {
    setHideToolbar((typeof disabled !== 'undefined' && disabled) || (typeof hide !== 'undefined' && hide))
  }, [disabled, hide])



  const [internalValue, setInternalValue] = useState(data || '')

  useEffect(() => {        
    setInternalValue(data)
  }, [data])
  

  const setFormValue = (value) => {
    let newValue = value;
    if (valueSelector) {
      newValue = {
        ...field.value,
        [valueSelector]: value,
      }
    }
    
    if (fieldProps?.required && !value) setFieldValue(fieldProps.name, newValue, false)
    else setFieldValue(fieldProps.name, newValue)

    if (onChange) onChange(newValue)
  }



  ClassicEditor.defaultConfig = {
    toolbar: {
      items:  [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'blockQuote',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        'insertTable',
        '|',
        'undo',
        'redo',
      ],
    },
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
    },
    language: 'en',
  }

  return ( 
    <Box
      sx={{
        '& .ck-editor': { opacity: hideToolbar ? '0.55 !important' : '', pointerEvents: hideToolbar ? 'none' : '' },
        '& .ck-toolbar': {
          borderRadius: `0 0.75rem 0 0 !important`,
          border: '1px solid rgba(0, 0, 0, 0.23)!important',
          display: hideToolbar ? 'none !important' : 'block'
        },
        '& .ck-toolbar .ck-toolbar__items': {
          display: 'block',
          whiteSpace: 'normal'
        },
        '& .ck-editor__editable': {
          borderRadius: `0 ${hideToolbar ? '0.75rem' : '0'} 0.75rem 0.75rem !important`,
          border: '1px solid rgba(0, 0, 0, 0.23)!important',
          borderTop:  !hideToolbar && 'none !important',
          padding: '0.75rem !important',
          background: hideToolbar &&'rgba(224, 224, 224, 0.4)' + '!important',
          height: height ? height : null
        },
        width: width ? width : null
      }}
      className="transparent-background"
    >
      <Box sx={{ width: '100%', position: 'relative' }} className="transparent-background">
        <Chip
          avatar={noIcon ? null : icon}
          color='default'
          label={label}
          sx={{
            fontSize: '1rem',
            borderRadius:  `${ELEMENT_RADIUS_MID} ${ELEMENT_RADIUS_MID} 0 0`,
            padding: '1.1rem 0.3rem',
          }}
        />
        {fieldProps?.required && !hideToolbar && (
          <span style={{ color: 'red', position: 'absolute', top: '0', marginLeft: '0.5rem' }}>*</span>
        )}
      </Box>
      <CKEditor
        editor={ClassicEditor}
        data={internalValue || ''}
        onChange={(event: any, editor: any) => {
          setInternalValue(editor.getData())
          debouncedChangeHandler(event, editor);
        }}
        onBlur={(event: any, editor: any) => {
          //setFormValue(editor.getData())
         
        }}
        // onReady={(editor) => {
        //   // You can store the "editor" and use when it is needed.
        //   console.log('Editor is ready to use!', editor)
        // }}
        // onFocus={(event, editor) => {
        //   console.log('Focus.', editor)
        // }}
      />
      {error && <p style={{ color: 'red', marginTop: '0.3rem' }}>{error}</p>}
    </Box>
  )
}

export default RichTextField
